"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.DeviceAPI = {
    /**
     * DEPRECATED
     */
    loginDevice: function (deviceId, password) {
        return index_1.axios.post('/api/v1/login/device', {
            email: deviceId,
            password: password,
        }).then(function (response) {
            var device = response.data.user;
            var authToken = response.data.authToken;
            return {
                device: response.data.user,
                authToken: response.data.authToken,
            };
        });
    },
    loginDeviceV2: function (deviceId, password) {
        return index_1.axios.post('/api/v1/login/device', {
            deviceId: deviceId,
            password: password,
        }).then(function (response) { return ({
            device: response.data.device,
            authToken: response.data.authToken,
        }); });
    },
    getDevices: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/devices").then(function (response) { return response.data.data; });
    },
    getCurrentDevice: function () {
        return index_1.axios.get('/api/v1/device/me').then(function (response) { return response.data; });
    },
    getDeviceById: function (companyId, deviceId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/device/" + deviceId).then(function (response) { return response.data; });
    },
    resetDevicePassword: function (companyId, deviceId, password) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/device/" + deviceId, {
            id: deviceId,
            password: password,
        }).then(function (response) { return response.data; });
    },
    updateMerrcoDevice: function (companyId, deviceId, merrcoDeviceUpdate) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/device/" + deviceId, __assign({ id: deviceId }, merrcoDeviceUpdate)).then(function (response) { return response.data; });
    },
    updateDevice: function (companyId, deviceId, updateDevice) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/device/" + deviceId, updateDevice).then(function (response) { return response.data; });
    },
};
//# sourceMappingURL=DeviceAPI.js.map